export const DELIVERY_METHOD = [
  {code: "inbox", label: "Inbox / Notifications Drawer", icon: 'mdi-cellphone-link'},
  {code: "portal_banner", label: "Staff Portal Web Banner", icon: 'mdi-monitor' },
]

export const QPLUS_DELIVERY_METHOD = [
  { code: "drawer", label: "Notification Drawer", icon: "mdi-cellphone-line"},
  { code: "qplus_banner", label: "Important Notices Banner", icon: "mdi-monitor" }
]

export const AUDIENCE = [
  {code: "Individuals", label: "Send to individuals", icon: "mdi-account-circle-outline"},
  {code: "Roles", label: "Send to roles", icon: "mdi-account-supervisor-circle-outline"},
  {code: "Everyone", label: "Send to everyone", icon: "mdi-account-multiple-outline"}
]

export const QPLUS_AUDIENCE = [
  {code: "Individuals", label: "Send to individuals", icon: "mdi-account-circle-outline"},
  {code: "Everyone", label: "Send to everyone", icon: "mdi-account-multiple-outline"}
]

export const APPROVERS = [
  {name: "John Smith", email: "john.smith@example.com", userID: "john.smith"},
  {name: "Sara Johnson", email: "sara.johnson@example.com", userID: "sara.johnson"},
  {name: "Simon Gethin", email: "simon.gethin@example.com", userID: "simon.gethin"}
]

export const SCHEDULE = [
  {code: "Immediately", label: "Send immediately", icon: "mdi-send-outline"},
  {code: "Later", label: "Schedule for later", icon: "mdi-clock-outline"}
]

export const PERMISSIONS = {
  'SCHOOL_STATUS_UPDATE': 'SCHOOL_STATUS_UPDATE'
}

export const ROLES = {
  'WEB_NOTIFICATION': 'ADMIN.WEBNOTIFICATION'
}

export const AUDIENCE_ROLES = [
  "DET.CASUAL",
  "DET.CONTRACTOR",
  "DET.STAFFSECONDMENT",
  "SCHOOL.CASUALNONTEACHER",
  "SCHOOL.CASUALTEACHER",
  "SCHOOL.CASUALCORPORATE",
  "SCHOOL.EXCHANGEPRINCIPAL",
  "SCHOOL.EXCHANGESUBEXECUTIVE",
  "SCHOOL.EXCHANGETEACHER",
  "SCHOOL.NONTEACHER",
  "SCHOOL.PRACTICE",
  "SCHOOL.SUBEXECUTIVE",
  "SCHOOL.PRINCIPAL",
  "SCHOOL.CORPORATE",
  "SCHOOL.TEACHER",
  "SCHOOL.STAFFOTHER",
  "SCHOOL.PRINCIPAL.DEPUTY.HS",
  "SCHOOL.PRINCIPAL.DEPUTY.PS",
  "DEC.COMMUNITIES",
  "DEC.ECEC",
  "DET.ACETEACHER",
  "DET.EXTERNALAUDITOR",
  "DET.GUEST",
  "DET.GUEST_BROWSE",
  "DET.GUESTLECTURER",
  "DET.USER",
  "DET.WORKEXPERIENCE",
  "SCHOOL.SES",
  "SCHOOL.TEACHER.APPLICANT.APPOINTED",
  "SCHOOL.STAFF.FORMER",
  "SCHOOL.STAFF.LEAVE",
  "DET.ACE"
]
